import NagAlert from "components/NagAlert";
import { useCompanySaleCheck } from "context/useCompanySaleCheck";
import { useConfigPermission } from "context/useConfigPermission";
import { useOrders } from "context/useOrderData";
import { useProductConfiguration } from "context/useProductConfiguration";
import { PromoItemProps, WebshopId } from "models/WebShop";
import { Link, useParams } from "react-router-dom";
import { isInfoTextConfigEmpty } from "utility/ProductUtility";
import { UrlPath } from "utility/routes";

const InfoTextPromo = ({showBuyPromo = true} : PromoItemProps) => {
  const params = useParams();
  const companyId = params.id ?? "";
  const { companySaleCheck } = useCompanySaleCheck();
  const { saleStatusByCompany } = useOrders();
  const { productConfigurationsByCompany } = useProductConfiguration();
  const { canConfig } = useConfigPermission();

  const path = `${UrlPath.Account.WebShopBase}/${companyId}/${UrlPath.Account.ProductConfig.InfoText}`;
  const configPath = `${UrlPath.Account.Company}/${params.id}/${UrlPath.Account.Actions.Products}/${UrlPath.Account.ProductConfig.InfoText}`;

  if (companyId === "" || companySaleCheck[companyId] === undefined)
    return null;

  const config = productConfigurationsByCompany[companyId];
  if (!config) return null;


  const showSalePromo = companySaleCheck[companyId]?.allowed && !saleStatusByCompany[companyId]?.orderStatuses.some(x => x.activeProducts.some(p => p.id === WebshopId.infoText)) && productConfigurationsByCompany[companyId]?.infoText === null;
  const showConfig = productConfigurationsByCompany[companyId].infoText !== undefined && productConfigurationsByCompany[companyId].infoText !== null && canConfig(companyId);
  const emptyInfoTextConfigNag = isInfoTextConfigEmpty(productConfigurationsByCompany[companyId].infoText);

  const nagDescription = "Beskrivelse av bedriften er ikke lagt til i bedriftens profil enda. Husk å fortelle hvem dere er og hvorfor kundene bør velge nettopp dere."


  return (showSalePromo && showBuyPromo) ? (
    <div className="card mt-4">
      <div className="card-header">
        <h2 className="fs-5">Beskrivelse av bedriften</h2>
      </div>
      <div className="card-body">
        <Link to={path}><img src="/min-bedrift-ill-beskrivelse.svg" width="800" height="520" alt="" className="cc-card-shop-promo-ill" /></Link>
        <p>Gi våre brukere en kortfattet beskrivelse av din bedrift.</p>
        <p className="mb-0"><Link to={path} className="btn btn-primary text-white">Kjøp beskrivelse</Link></p>
      </div>
    </div>
  ) : (
    showConfig ? (

      emptyInfoTextConfigNag ?

        <NagAlert title="Beskrivelse av bedriften" path={configPath} shTitle="beskrivelse" description={nagDescription} />

        :

        <div className="card mt-4">
          <div className="card-header">
            <h2 className="fs-5">Beskrivelse av bedriften</h2>
          </div>
          <div className="card-body">
            <p>{productConfigurationsByCompany[companyId].infoText?.text}</p>
            <div className="mb-0 d-md-flex justify-content-between align-items-center">
              <div>
                <Link
                  to={configPath}
                  className="btn btn-primary text-white">Endre beskrivelse</Link>
              </div>
              <div className="mt-3 mt-md-0">
                <Link
                  to={configPath}
                  className="cc-icon-text-link text-muted"><i className="bi bi-box"></i> <span>Kjøpt produkt</span></Link>
              </div>
            </div>
          </div>
        </div>

    )
      : null

  )
};

export default InfoTextPromo;